import { LS_WALLET_ID_KEY } from '../constants';

const getLsWalletId = () => {
	return localStorage.getItem(LS_WALLET_ID_KEY);
};

export default getLsWalletId;
